module.exports = __webpack_public_path__ + "static/img_1623-ea02278f1f97650c94aaab022c28a6f1.webp";